const THEMES = {
    zebra: 0,
    yellow: 1,
    darkgray: 2,
    illustration: 3,
    lightgray: 4,
    white: 5,
    zebraBlue: 6
};

module.exports.default = module.exports.THEMES = THEMES;

module.exports.getThemeClassNames = (css, theme) => {
    let classNames = {};
    Object.keys(THEMES).map(s => { 
        if(css[s]){
            classNames = {
                ...classNames,
                [css[s]]: theme === THEMES[s]
            };
        }
    });
    return classNames;
};



// WEBPACK FOOTER //
// ./src/constants/themes.js